export const AIRBRAKE_PROJECT_ID = 217882;
export const AIRBRAKE_PROJECT_KEY = '6d7b08a83db80dc921bcdc71b3efa9e6';

/**
 * Default sampling rate for error reporting to Airbrake
 * 0.00001 = 0.001% of errors (1 in 100,000)
 */
export const AIRBRAKE_REPORTING_RATE = 0.00001;

/**
 * Sampling rate for bundles built for a canary slot. Acts as a floor over
 * AIRBRAKE_REPORTING_RATE, so a canary reports 1000x more of the default-rate
 * traffic than a stable build during its validation window.
 *
 * Equal to BAD_CALLERS_SAMPLING_RATE (sampling-rules.ts), so it does not lift
 * the callers SAMPLING_RULES already matches. Raise it past that rate to see
 * more of them.
 */
export const CANARY_AIRBRAKE_REPORTING_RATE = 0.01;

/**
 * Equativ's Datadog org is on the EU site (equativ.datadoghq.eu), not the .com default.
 */
export const DATADOG_SITE = 'datadoghq.eu';

/**
 * Datadog's browser log intake endpoint, per https://docs.datadoghq.com/logs/log_collection/javascript/.
 */
export const DATADOG_INTAKE_URL = `https://browser-intake-${DATADOG_SITE}/api/v2/logs`;

export const DATADOG_SERVICE = 'groundcontrol';

/**
 * Most Datadog logs one Boot (one gc.js execution) sends. Sampling bounds volume across
 * pages; this bounds a single execution stuck in an error loop, the browser analogue of the
 * org's MaxLogsPerMinute burst guard (Confluence RND "Datadog Sampling Guidelines").
 * Logs dropped past it carry no weight, so a looping Boot is undercounted - acceptable,
 * since it is an anomaly rather than volume to reconstruct.
 */
export const DATADOG_MAX_LOGS_PER_BOOT = 5;

/**
 * Highest rate at which any Error Report reaches Datadog, whatever rate reportError kept it
 * at: the 1% paths (SAMPLING_RULES callers, canary builds, call-site overrides) are the burst
 * risk against the org-wide Datadog ingestion limit. Compiled on purpose, so no remote setting
 * can lift GC's Datadog volume past it; raising it is a reviewed deploy.
 */
export const DATADOG_SAMPLING_RATE_CEILING = 0.001;

/**
 * AWS Lambda URL for S3 logging
 */
export const LAMBDA_URL = 'https://ljv37e7t7uuolmfy4tnog4w7za0auwrm.lambda-url.us-east-1.on.aws';

/**
 * S3 bucket base URL for accessing logged data
 */
export const LOG_BASE_URL = 'https://sfar-data-production.s3.amazonaws.com/logging';
